import { render, staticRenderFns } from "./ProjectDrawer.vue?vue&type=template&id=20fd9d30&"
import script from "./ProjectDrawer.vue?vue&type=script&lang=js&"
export * from "./ProjectDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports